import React, { useState } from "react";
import CustomHeading from "../../common/CustomHeading";
import CustomSearch from "../../common/CustomSearch";
import CustomButton from "../../common/CustomButton";
import CustomTable from "../../common/CustomTable";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { BiEdit } from "react-icons/bi";
import { Sidebar } from "primereact/sidebar";
import CustomSidebar from "../../common/CustomSidebar";
import UserInfoSidebar from "./UserInfoSidebar";
import useUser from "../../hooks/useUser";

import { ToastContainer } from "react-toastify";
import InfoModel from "../../shareableContainer/InfoModel";
import { getBasePathByUserRole } from "../../../utils/roleRoutes";
import { useNavigate } from "react-router-dom";

const UserList = () => {
  const {
    searchTerm,
    setSearchTerm,
    selectedRole,
    handleRoleChange,
    userList,
    userCount,
    pageSize,
    currentPage,
    nextPageToken,
    prevPageToken,
    hasMore,
    loading,
    handleSearchSubmit,
    handleSearchChange,
    handlePageChange,
    handlePageSizeChange,
    handleUserCreate,
    handleUserUpdate,
    userForm,
    setUserForm,
    visibleForm,
    setVisibleForm,
    handleUserDetails,
    handleToggleClick,
    dealCount,
    leadCount,
    status,
    infoShow,
    setInfoShow,
    roleCount,
    handleReassignLead,
    handleDealReassign,
    handleDeactiveUser,
    user,
  } = useUser();

  const paths = getBasePathByUserRole();
  const navigate = useNavigate();

  const columns = [
    {
      key: "name",
      title: "Name",
      render: (text , record) => (
        <div
        
          className=" capitalize truncate cursor-pointer text-center"
        >
          <div className="flex text-start flex-col gap-2 " >
            <div className="capitalize">
            {record?.name}
            </div>
            <div className="text-customGreen">
           Emp ID : {record?.employeeId}
            </div>
          </div>
        
        </div>
      ),
    },
    {
      key: "role",
      title: "Role",
      render: (text) => <div className="truncate">{text}</div>,
    },
    {
      key: "teamNames",
      title: "Team",
      render: (text) => {
        const teamName = text[0]?.name || "";
        const teamLength = text?.length || 0;
        if (teamLength === 0) {
          return <div className="text-gray-500">No Team</div>;
        }
        if (teamLength === 1) {
          return <div className="truncate">{teamName}</div>;
        }
        const teamText = text.map((team) => team.name).join(", ");
        return (
          <div title={teamText} className="truncate cursor-pointer">
            {teamName ? teamName : "No Team"}
            {teamLength > 1 && (
              <span className="text-blue-500 ml-2">+{teamLength - 1}</span>
            )}
          </div>
        );
      },
    },
    {
      key: "status",
      title: "Status",
      render: (_, record) => (
        <div className="truncate">
          <div className="flex justify-center  gap-4">
         {record.status ?<div className="flex items-center gap-3">
        <span
            className={`text-sm font-medium ${
              record.status ? "" : "text-red-600"
            }`}
          >
            {"Deactive"}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={record.status}
              onChange={(e) =>
             {
              handleToggleClick(record.id)
              handleUserDetails(record)
             }
                 
              }
              className="sr-only peer"
            />
            <div
              className={`w-11 h-6 rounded-full peer-focus:outline-none after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                record.status ? "bg-green-600" : "bg-red-500"
              } peer-checked:after:translate-x-full`}
            />
          </label>
          <span
            className={`text-sm font-medium ${
              record.status ? "text-green-600" : ""
            }`}
          >
            { "Active"}
          </span>
        </div> : (<>
         
         <div className="text-red-500">
          Deactive
         </div>
        
        </>)}
      </div>
        </div>
      ),
    },
    {
      key: "Action",
      title: "Action",
       render: (_, record) => (
              <div
                onClick={() => {
                  navigate(`${paths}/users/user-info`, {
                    state: { userData: record },
                  });
                }}
                className="flex justify-center items-center h-full cursor-pointer"
              >
                <BiEdit className="text-blue-500 text-lg" />
              </div>
            ),
    },
  ];

  const userTab = [
    { lable: "All Users", count: roleCount?.roleWiseCount?.BOD + roleCount?.roleWiseCount?.Telecaller + roleCount?.roleWiseCount?.["Marketing Executive"] + roleCount?.roleWiseCount?.["Field Worker"] + roleCount?.roleWiseCount?.MD + roleCount?.roleWiseCount?.Admin + roleCount?.roleWiseCount?.["Lead Uploader"] + roleCount?.roleWiseCount?.CMO || 0 },
    { lable: "BOD", count: roleCount?.roleWiseCount?.BOD || 0 },
    { lable: "Telecaller", count: roleCount?.roleWiseCount?.Telecaller || 0  },
    { lable: "Marketing Executive", count: roleCount?.roleWiseCount?.["Marketing Executive"] || 0 },
    { lable: "Field Worker", count: roleCount?.roleWiseCount?.["Field Worker"] || 0 },
    { lable: "MD", count: roleCount?.roleWiseCount?.MD || 0 },
    { lable: "Admin", count: roleCount?.roleWiseCount?.Admin || 0 },
    { lable: "Lead Uploader", count: roleCount?.roleWiseCount?.["Lead Uploader"] || 0 },
    { lable: "CMO", count: roleCount?.roleWiseCount?.CMO || 0 },
    // { lable: "Procurement Head", count: roleCount?.roleWiseCount?.["Procurement Head"] || 0 },
    // { lable: "Backend", count: roleCount?.roleWiseCount?.Backend || 0 },
    // { lable: "Frontend", count: roleCount?.roleWiseCount?.Frontend || 0 },
    // { lable: "Rough Drafter", count: roleCount?.roleWiseCount?.["Rough Drafter"] || 0 },
    // { lable: "Procurer", count: roleCount?.roleWiseCount?.Procurer || 0 },
    // { lable: "HR", count: roleCount?.roleWiseCount?.HR || 0 }
  ];
  console.log("userList", userList) 
  console.log("userForm", userForm);

  return (
    <>
      <div className="bg-appGrayBackground pb-7">
         <AdminAppBar />
        <ToastContainer/>
        <div className="pt-28 px-6">
          <div className="flex items-center justify-between">
            <CustomHeading
              title={
                <>
                  Users 
                </>
              }
              isIcon={true}
            />
            <div className="flex items-center gap-4">
              <CustomSearch
                placeholder={"Search User"}
                searchTerm={searchTerm}
                handleSearchSubmit={handleSearchSubmit}
                handleSearchChange={handleSearchChange}
              />
              {/* <CustomButton
                label={"Create User"}
                onClick={() => setVisibleForm(true)}
              /> */}
            </div>
          </div>

          <div className="flex items-center justify-between mt-8">
            <div className="flex overflow-x-auto py-5 md:justify-start gap-3 hide-scrollbar">
              {userTab.map((list, index) => (
                <button
                  key={index}
                  onClick={() =>
                    handleRoleChange(
                      list.lable === "All Users" ? null : list.lable
                    )
                  }
                  className={`px-6 h-[50px] rounded-3xl whitespace-nowrap ${
                    selectedRole === list.lable ||
                    (!selectedRole && list.lable === "All Users")
                      ? "bg-white text-customGreen text-base font-semibold shadow"
                      : "bg-white text-gray-700 hover:bg-gray-50"
                  }`}
                >
                  {list.lable} ({list.count})
                </button>
              ))}
            </div>
          </div>

          <div className="w-full mt-[20px]">
            <CustomTable
              columns={columns}
              data={userList}
              isPagination={true}
              pageSize={pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              currentPage={currentPage}
              nextId={nextPageToken}
              prevId={prevPageToken}
              hasMore={hasMore}
              loading={loading}
            />
          </div>
          <CustomSidebar
            visible={visibleForm}
            onHide={() => {
              setVisibleForm(false);
              setUserForm({
                name: "",
                role: "",
                team: [],
                email: "",
                empId: "",
                phone: "",
                status: true,
              });
            }}
            title="User Information"
          >
            <UserInfoSidebar
              userForm={userForm}
              loading={loading}
              setUserForm={setUserForm}
              handleUserCreate={handleUserCreate}
              handleUserUpdate={handleUserUpdate}
                // handleToggleClick={handleToggleClick}
            />
          </CustomSidebar>

          <InfoModel
        show={infoShow}
        leadCount={leadCount}
        dealCount={dealCount}
        reassignHandle={()=>{
            handleReassignLead(userForm?.userId , userForm?.team?.map((team) => team.id) || [])
        }}
        dealReassignHandle={()=>{
            handleDealReassign(userForm?.userId)
        }}
        userDeactiveHandle={()=>{
            handleDeactiveUser(userForm?.userId)
        }}
        title={`${
          leadCount == 0 || dealCount === 0
            ? "Are You Sure"
            : "User Has Active Clients"
        } `}
        message={
          leadCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {leadCount} Clients in leads
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500">{userForm?.name}</span>.
            </>
          ) : dealCount > 0 ? (
            <>
              This user is currently managing{" "}
              <span className="text-orange-500">
                {dealCount} Clients in Deal
              </span>
              . So, Manually Reassign the Responsible person before disabling{" "}
              <span className="text-blue-500 truncate whitespace-pre-wrap">
                {userForm?.name}
              </span>
              .
            </>
          ) : (
            <>
              “Are you sure you want to disable this user? They will be logged
              out and lose access to the system immediately.”
            </>
          )
        }
        close={() => {
          setInfoShow(false);
       
        }}
      />
        </div>
      </div>
    </>
  );
};

export default UserList;
